import { useRef } from 'react';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Button from '@ui/buttons/button/button';
import Popover from '@ui/popover/popover';
import { IWatermarkSet } from '@/types/watermarks.types';

interface WatermarkLibraryListItemProps {
  watermark: IWatermarkSet;
  isSelected?: boolean;
  onSelect?: (watermark: IWatermarkSet | null) => void;
  onEdit?: (watermark: IWatermarkSet) => void;
  onDuplicate?: (watermark: IWatermarkSet) => void;
  onDelete?: (watermark: IWatermarkSet) => void;
}

const WatermarkLibraryListItem = ({
  watermark,
  isSelected,
  onSelect,
  onEdit,
  // onDuplicate, TODO
  onDelete,
}: WatermarkLibraryListItemProps) => {
  const portalRef = useRef<HTMLDivElement | null>(null);

  return (
    <Container
      width="100%"
      design="GlobalCont2"
      borderRadius="8px"
      border={isSelected ? '1px solid var(--global-ico-text-1)' : '1px solid transparent'}
      className="padding-16 flex ai-center jc-space-between cursor-pointer"
      onClick={() => onSelect?.(isSelected ? null : watermark)}
    >
      <Container className="flex flex-1 ai-center gap-16">
        <Container
          className="flex ai-center jc-center"
          width="69px"
          height="40px"
          design="GlobalCont3"
          borderRadius="8px"
        >
          <Icon name={ICONS.WATERMARK} size={24} />
        </Container>
        <Container className="flex-1">
          <Text className="S3" design="GlobalIcoText1">
            {watermark.name}
          </Text>
        </Container>
        <Popover
          stopPropagation
          closeOnClick
          cycleWithArrowKeys
          portalEl={portalRef}
          renderTriggerButton={({ open }) => (
            <Button
              design="LocalBttnSec"
              fixedState={open ? 'active' : undefined}
              onClick={(e) => e.stopPropagation()}
              clear
              className="square-32 radius-full flex-column ai-center jc-center"
            >
              <Icon name={ICONS.THREE_DOTS_HORIZONTAL} size={12} color="var(--gray-300)" />
            </Button>
          )}
        >
          {({ triggerBounds }) => (
            <Container
              design="GlobalCont3"
              borderRadius="12px"
              width="166px"
              className="position-fixed flex-column"
              style={{
                top: (triggerBounds?.bottom ?? 0) + 4,
                left: (triggerBounds?.right ?? 0) - 166,
                zIndex: 99999,
              }}
            >
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit?.(watermark);
                }}
                className="flex ai-center gap-8"
                hoverBackgroundColor="var(--gray-700)"
                borderRadius="12px"
                width="100%"
                height="32px"
                style={{
                  borderBottomLeftRadius: '0px',
                  borderBottomRightRadius: '0px',
                }}
              >
                <Icon name={ICONS.EDIT} />
                <Text textAlign="center" className="P1">
                  Edit / Preview
                </Text>
              </Button>
              {/* <Button
                onClick={(e) => { e.stopPropagation(); onDuplicate?.(watermark); }}
                className="flex ai-center gap-8"
                borderRadius='0px'
                width="100%"
                height="32px"
                hoverBackgroundColor="var(--gray-700)"
              >
                <Icon name={ICONS.COPY_FILLED} />
                <Text textAlign="center" className="P1">
                  Duplicate
                </Text>
              </Button> */}
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete?.(watermark);
                }}
                className="flex ai-center gap-8"
                borderRadius="12px"
                width="100%"
                height="32px"
                hoverBackgroundColor="var(--gray-700)"
                style={{
                  borderTopLeftRadius: '0px',
                  borderTopRightRadius: '0px',
                }}
              >
                <Icon color="var(--semantic-red-500)" name={ICONS.DELETE_TRASH_BIN} />
                <Text color="var(--semantic-red-500)" textAlign="center" className="P1">
                  Delete
                </Text>
              </Button>
            </Container>
          )}
        </Popover>
      </Container>
    </Container>
  );
};

export default WatermarkLibraryListItem;
